import React from 'react'

const Cplus = () => {
  return (
    <div className='w-[90%] mx-auto md:flex items-start '>
        <div className='md:w-1/2'>
            <p className='font-[400] text-[10px] leading-[10px] lg:text-[14px] lg:leading-[20px] text-[#141414]'>Staff</p>
            <p className='text-[17px] leading-[23px] lg:text-[21px] leading-[29px]'>Rachel Zane</p>
            <p className='font-[400] text-[14px] leading-[20px] text-[#141414]'>Website</p>
            <p className='text-[17px] leading-[23px] lg:text-[21px] leading-[29px]'>www.personalwebsite.com</p>
        </div>
        <div className='md:w-1/2 '>
            <div className='w-full lg:w-[80%] font-[400] space-y-4'>
            <div className=' text-[30px] leading-[30px] md:text-[35px] md:leading-[35px] lg:text-[42px] lg:leading-[42px]'>
            In today's fast-paced tech industry, mastering C++ is crucial for a successful career in software development. Covering everything from basic syntax to advanced concepts.
            </div>
            <div className='text-[16px] leading-[18px] md:text-[14px] md:leading-[20px] lg:text-[16px] lg:leading-[23px]'>
            Our C++ course is meticulously crafted to cater to today's dynamic tech landscape, where proficiency in C++ is indispensable for software developers aiming to thrive. Beginning with foundational syntax and data types, participants will swiftly progress through advanced topics such as object-oriented programming, memory management, and leveraging the Standard Template Library (STL).
            </div>
            <div className='text-[16px] leading-[18px] md:text-[14px] md:leading-[20px] lg:text-[16px] lg:leading-[23px]'>
            Emphasis is placed on hands-on learning, ensuring that each concept is reinforced through practical coding exercises and real-world applications. Whether you're a seasoned developer looking to enhance your skill set or a newcomer to programming, this course provides a comprehensive pathway to mastering C++, equipping you with the expertise needed to tackle complex software challenges with confidence.
            </div>
            </div>

        </div>
    </div>
  )
}

export default Cplus